import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import ThemeCustomizer from '../ui/ThemeCustomizer';
import LogoDark from '../../Assets/HD Quality Logo 2.svg';

const EMPLOYEE_FEATURES = [
  'Manage assigned clients',
  'Prepare tax filing checklists',
  'Documents & bookkeeping support',
];

const AuthShell = ({ title, subtitle, children, footer }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen flex overflow-hidden ${isDarkMode ? 'dark bg-black' : 'bg-gray-50'}`}>
      <div
        className="hidden lg:flex lg:w-1/2 xl:w-[55%] relative shrink-0 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, rgb(var(--primary-700)), rgb(var(--primary-800)), #000000)' }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-24 -right-24 w-72 h-72 bg-secondary-500/20 rounded-full blur-3xl" />
          <div className="absolute bottom-20 left-10 w-56 h-56 bg-primary-400/15 rounded-full blur-3xl" />
          <div className="absolute top-28 right-16 w-16 h-16 bg-white/10 rounded-2xl rotate-12" />
        </div>

        <div className="relative z-10 flex flex-col h-full w-full p-10 xl:p-14">
          <img src={LogoDark} alt="BooksComply" className="h-10 xl:h-11 w-auto drop-shadow-md self-start" />

          <div className="flex-1 flex flex-col justify-center max-w-lg">
            <h1 className="text-3xl xl:text-4xl font-bold text-white leading-tight mb-4">
              Employee Portal
            </h1>
            <p className="text-base xl:text-lg text-white/80 leading-relaxed mb-10">
              Your workspace for client management, checklists, and support.
            </p>

            <ul className="space-y-4">
              {EMPLOYEE_FEATURES.map((feature) => (
                <li key={feature} className="flex items-center gap-3">
                  <span className="flex-shrink-0 w-9 h-9 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center border border-white/20">
                    <FaCheckCircle className="w-4 h-4 text-white" />
                  </span>
                  <span className="text-white/90 text-sm xl:text-base font-medium">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} BooksComply. All rights reserved.
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 xl:w-[45%] flex flex-col min-h-screen bg-white dark:bg-black">
        <header className="flex items-center justify-between gap-4 px-6 sm:px-8 lg:px-10 py-5 shrink-0 border-b border-gray-100 dark:border-neutral-800">
          <img src={LogoDark} alt="BooksComply" className="h-9 sm:h-10 w-auto lg:invisible" />
          <ThemeCustomizer variant="auth" />
        </header>

        <main className="flex-1 overflow-y-auto flex items-center justify-center px-6 sm:px-8 lg:px-10 py-8 sm:py-10">
          <div className="w-full max-w-md">
            <div className="mb-8 text-center lg:text-left">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-2">
                {title}
              </h2>
              {subtitle && (
                <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base">{subtitle}</p>
              )}
            </div>

            {children}

            {footer && <div className="mt-8">{footer}</div>}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AuthShell;
